import script from "./productV2Commons.vue?vue&type=script&lang=js"
export * from "./productV2Commons.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__